import { site } from "../data/site";

export function dateOnly(value: string) {
  return value.slice(0, 10);
}

export function todayInSiteTimeZone(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en", {
    timeZone: site.timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(date);

  const year = parts.find((part) => part.type === "year")?.value ?? "1970";
  const month = parts.find((part) => part.type === "month")?.value ?? "01";
  const day = parts.find((part) => part.type === "day")?.value ?? "01";

  return `${year}-${month}-${day}`;
}

export function isFutureDate(value: string, now = new Date()) {
  return dateOnly(value) > todayInSiteTimeZone(now);
}

export function formatDate(value: string) {
  return new Intl.DateTimeFormat("en", {
    dateStyle: "medium",
    timeZone: site.timeZone
  }).format(new Date(`${dateOnly(value)}T00:00:00+08:00`));
}
